import { AnyAction } from 'redux'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { defaultFlow } from 'redux/config/saga/Common'
import { dashboardActions } from 'features/Dashboard/dashboardActions'
import { dashboardReducers } from 'features/Dashboard/dashboardSlice'
import DashboardService from 'features/Dashboard/dashboardService'

export function* getDashboardBulkData(action: AnyAction) {
  yield defaultFlow(
    action,
    DashboardService.getDashboardBulkData,
    dashboardReducers.setDashboardBulkDataSuccess
  )
}

export function* getDashboardMapData(action: AnyAction) {
  yield defaultFlow(
    action,
    DashboardService.getDashboardMapData,
    dashboardActions.getDashboardMapDataSuccess
  )
}

export function* getDashboardTrackers(action: AnyAction) {
  yield defaultFlow(
    action,
    DashboardService.getDashboardTrackers,
    dashboardReducers.setDashboardTrackersSuccess
  )
}

export function* getDashboardProgramStats(action: AnyAction) {
  yield defaultFlow(
    action,
    DashboardService.getDashboardProgramStats,
    dashboardReducers.setDashboardProgramStatsSuccess
  )
}

export function* getDashboardProgramCards(action: AnyAction) {
  yield defaultFlow(
    action,
    DashboardService.getDashboardProgramCards,
    dashboardReducers.setDashboardProgramCardsSuccess
  )
}

export function* getDashboardLocationCards(action: AnyAction) {
  yield defaultFlow(
    action,
    DashboardService.getDashboardLocationCards,
    dashboardReducers.setDashboardLocationCardsSuccess
  )
}

export function* getDashboardLocationDetail(action: AnyAction) {
  yield put(dashboardReducers.setDashboardLocationDetailLoading())
  try {
    const res = yield call(
      DashboardService.getDashboardLocationDetail,
      action.payload
    )
    yield put(dashboardReducers.setDashboardLocationDetailSuccess(res.data))
  } catch (_error) {
    yield put(dashboardReducers.setDashboardLocationDetailFailed())
  }
}

export function* getDashboardTransitExceptions(action: AnyAction) {
  yield defaultFlow(
    action,
    DashboardService.getDashboardTransitExceptions,
    dashboardReducers.setDashboardTransitExceptionsSuccess
  )
}

export function* updateDashboardTransitExceptionStatus(action: AnyAction) {
  yield defaultFlow(
    action,
    DashboardService.updateDashboardTransitExceptionStatus,
    dashboardReducers.updateDashboardTransitExceptionSuccess
  )
}

/**************************************
 * Watchers
 **************************************/

export function* watchGetDashboardBulkData() {
  yield takeEvery(
    [dashboardActions.getDashboardBulkData.type],
    getDashboardBulkData
  )
}

export function* watchGetDashboardMapData() {
  yield takeEvery(
    [dashboardActions.getDashboardMapData.type],
    getDashboardMapData
  )
}

export function* watchGetDashboardTrackers() {
  yield takeEvery(
    [dashboardActions.getDashboardTrackers.type],
    getDashboardTrackers
  )
}

export function* watchGetDashboardProgramStats() {
  yield takeEvery(
    [dashboardActions.getDashboardProgramStats.type],
    getDashboardProgramStats
  )
}

export function* watchGetDashboardProgramCards() {
  yield takeEvery(
    [dashboardActions.getDashboardProgramCards.type],
    getDashboardProgramCards
  )
}

export function* watchGetDashboardLocationCards() {
  yield takeEvery(
    [dashboardActions.getDashboardLocationCards.type],
    getDashboardLocationCards
  )
}

export function* getDashboardProgramDetail(action: AnyAction) {
  yield put(dashboardReducers.setDashboardProgramDetailLoading())
  try {
    const res = yield call(
      DashboardService.getDashboardProgramDetail,
      action.payload
    )
    yield put(dashboardReducers.setDashboardProgramDetailSuccess(res.data))
  } catch (_error) {
    yield put(dashboardReducers.setDashboardProgramDetailFailed())
  }
}

export function* clearDashboardLocationDetail(_action: AnyAction) {
  yield put(dashboardReducers.clearDashboardLocationDetail())
}

export function* clearDashboardProgramDetail(_action: AnyAction) {
  yield put(dashboardReducers.clearDashboardProgramDetail())
}

export function* watchGetDashboardLocationDetail() {
  yield takeEvery(
    [dashboardActions.getDashboardLocationDetail.type],
    getDashboardLocationDetail
  )
}

export function* watchGetDashboardProgramDetail() {
  yield takeEvery(
    [dashboardActions.getDashboardProgramDetail.type],
    getDashboardProgramDetail
  )
}

export function* watchClearDashboardProgramDetail() {
  yield takeEvery(
    [dashboardActions.clearDashboardProgramDetail.type],
    clearDashboardProgramDetail
  )
}

export function* watchClearDashboardLocationDetail() {
  yield takeEvery(
    [dashboardActions.clearDashboardLocationDetail.type],
    clearDashboardLocationDetail
  )
}

export function* watchGetDashboardTransitExceptions() {
  yield takeEvery(
    [dashboardActions.getDashboardTransitExceptions.type],
    getDashboardTransitExceptions
  )
}

export function* watchUpdateDashboardTransitExceptionStatus() {
  yield takeEvery(
    [dashboardActions.updateDashboardTransitExceptionStatus.type],
    updateDashboardTransitExceptionStatus
  )
}

export default function* () {
  yield all([
    watchGetDashboardBulkData(),
    watchGetDashboardMapData(),
    watchGetDashboardTrackers(),
    watchGetDashboardProgramStats(),
    watchGetDashboardProgramCards(),
    watchGetDashboardLocationCards(),
    watchGetDashboardLocationDetail(),
    watchGetDashboardProgramDetail(),
    watchClearDashboardLocationDetail(),
    watchClearDashboardProgramDetail(),
    watchGetDashboardTransitExceptions(),
    watchUpdateDashboardTransitExceptionStatus(),
  ])
}
